import { useEffect, useState } from 'react';
import { load_session_care_requests } from '../../../util_components/care_request/care_request_api';
import { current_care_cancel_record, may_have_care_cancel_time } from './session_change_rules';

// The Care record that sets a teacher cancel's request time, or null (none, not loaded yet, or the read failed).
// A failed read keeps the time field: apis refuses a correction such a record overrides.
export default function useCareCancelRecord(session_uuid, session_details) {
  const [record, setRecord] = useState(null);
  const wanted = may_have_care_cancel_time(session_details);
  const status = session_details.session_status;
  useEffect(() => {
    if (!session_uuid || !wanted) return undefined;
    let live = true;
    load_session_care_requests(session_uuid)
      .then((view) => {
        if (live) setRecord(current_care_cancel_record(view, status));
      })
      .catch((e) => {
        console.error('care cancel record read failed', e?.response?.status || e?.message);
      });
    return () => {
      live = false;
    };
  }, [session_uuid, wanted, status]);
  return record;
}
